import { postData } from "./apiServices";

const EnquiryDemoDetails = async (userData: any) => {
    console.log('userData', userData);

    // Verify CAPTCHA
    // const captchaResponse = await verifyCaptcha(captchaToken);
    // if (!captchaResponse.success) {
    //     return captchaResponse;
    // }

    const Payload = {
        firstName: userData?.fname,
        lastName: userData?.lname,
        contactNumber: userData?.Cnumber,
        email: userData?.email,
        description: userData?.message,
        companyName: userData?.ComName

    };

    const endpoint = 'masterPortal/createDemoRequest';
    try {
        const response = await postData(endpoint, Payload);
        return response;
    } catch (error) {
        console.error('Signup failed:', error);
        throw error;
    }
};
export { EnquiryDemoDetails };